<mat-dialog-content>
    <h4 *ngIf="data.titel" mat-dialog-title style="margin: 0px;">{{data.titel}}</h4>
    <h4 *ngIf="!data.titel" mat-dialog-title style="margin: 0px;">Bitte bestätigen</h4>
    <span>{{data.frage}}</span>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" tabindex="1" (click)="close(true)"><span *ngIf="data.ja">{{data.ja}}</span><span *ngIf="!data.ja">Ja</span></button>
    <button mat-button tabindex="-1" (click)="close(false)"><span *ngIf="data.ja">{{data.nein}}</span><span *ngIf="!data.nein">Nein</span></button>
  </mat-dialog-actions>
  